module.exports = __webpack_public_path__ + "img/hovering.a73d3b70.gif";